let resumeData = {
  "imagebaseurl":"https://github.com/dkrystall/",
  "name": "David Krystall",
  "nickname":"Dave",
  "role": "Software Engineer",
  "linkedinId":"david-krystall-64646a15",
  "skypeid": "",
  "roleDescription": " I like tinkering in various parts of the development stack and like to learn about new technologies, or play games and piano in my free time.",
  "socialLinks":[
      {
        "name":"linkedin",
        "url":"https://www.linkedin.com/in/david-krystall-64646a15/",
        "className":"fa fa-linkedin"
      },
      {
        "name":"github",
        "url":"https://github.com/dkrystall/",
        "className":"fa fa-github"
      },
      {
        "name":"twitter",
        "url":"http://twitter.com/retebitall",
        "className":"fa fa-twitter"
      },
      {
        "name":"myspace",
        "url":"https://www.youtube.com/watch?v=dQw4w9WgXcQ",
        "className":"fa fa-myspace"
      }
    ],
  "aboutme":"I am currently a Software Engineer working in Los Angeles, California. The majority of my time is spent coding iOS applications using Swift with XCode. I've recently begun transitioning into doing front end work with SwiftUI. In my spare code time I also enjoy learning new methodologies and currently studying Functional Programming with Scala. I'm also a classical pianist, an avid gamer, and a movie lover.",
  "address":"Los Angeles, California, USA",
  "website":"https://github.com/dkrystall/",
  "email":"dave@davidkrystall.com",
  "education":[
    {
      "UniversityName":"California State University, Los Angeles",
      "specialization":"Computer Science",
      "MonthOfPassing":"Dec",
      "YearOfPassing":"2019",
      "Achievements":"Computer Vision Leader for Robosub 2019 Team"
    }
  ],
  "work":[
    {
      "CompanyName":"Ontometrics",
      "specialization":"Software Engineer",
      "MonthOfLeaving":"August",
      "YearOfLeaving":"2020",
      "Achievements":""
    },
    {
      "CompanyName":"Torres Martinez Tribal TANF",
      "specialization":"Case Assistant",
      "MonthOfLeaving":"Feb",
      "YearOfLeaving":"2015",
      "Achievements":""
    }
  ],
  "skillsDescription":"I have a wide range of Software Engineering skills. I've developed simple SPA websites using Static Generators and Javascript Frameworks, I have also worked on more complex Web Applications with web servers as well as serverless architectures using AWS. I have worked on Mobile applications, Apple Apps using Swift with Xcode and SwiftUI/UIKit; as well as Android Apps using Kotlin with Jetpack and Jetpack Compose. I've also developed state machines for robotics projects; as well as computer vision systems using Darknet's YOLOv3 nerual network for real-time interaction with autonomous systems. I also have Development Operations experience, deploying TDD solutions using Continuous Integration and Continuous Deployment using JetBrains and Jenkins. I'm also familiar with many Amazon Web Services, I've used Route53, MobileHub, Elastic Beanstalk, S3, Kinesis, AppSync, DynamoDB, RDS, EC2, and AWS Lambda. ",
  "skills":[
    {
      "skillname":"Swift"
    },
    {
      "skillname":"Xcode"
    },
    {
      "skillname":"Kotlin"
    },
    {
      "skillname":"Android"
    },
    {
      "skillname":"Java"
    },
    {
      "skillname":"HTML5"
    },
    {
      "skillname":"CSS3"
    },
    {
      "skillname":"Javascript+ES6"
    },
    {
      "skillname":"Typescript"
    },
    {
      "skillname":"Node with NPM"
    },
    {
      "skillname":"Reactjs"
    },
    {
      "skillname":"AWS"
    },
    {
      "skillname":"DevOps"
    },
    {
      "skillname":"Python"
    },
    {
      "skillname":"C++"
    },
    {
      "skillname":"ROS"
    },
    {
      "skillname":"Scala"
    }
  ],
  "portfolio":[
    {
      "id":"0",
      "name":"D-Minder",
      "description":"iOS and Android App",
      "stack":["Swift with Xcode","Cocoa","SwiftUI","CoreData","CloudKit","Foundation","Android","Kotlin","Jetpack"],
      "responsibilities": "Majority of responsibilities on iOS. Responsible for refactoring solar calculations using bezier curve functions with Swift. Designing and developing front end components (Timer, HomeScreen, History). Localizing the iOS mobile application into Spanish, Italian, and Portuguese. ",
      "imgurl":"images/portfolio/dminder/dminder2.png",
      "url":"http://dminder.ontometrics.com"
    },
    {
      "id":"1",
      "name":"Robosub",
      "description":"Robotics - Autonomous Underwater Vehicle",
      "stack":["Python","C++","Robot Operation System","OpenCV","Darknet YOLOv3","Ubuntu 18.03","Arduino"],
      "responsibilities": "Main responsibility was for researching and implementing a Computer Vision system using Convolution Neural Networks to be integrated with an autonomous underwater vehicle running the Robot Operating System. It was implemented and trained using Darknet YOLOv3. Had to install camera drivers and mount them to ROS using python. I made an observer using Python with ROS to listen to changes in the camera node, to be fed to the Computer Vision node to give instructions to the AUV. I also helped implement the state machine used by the robot to navigate predetermined obstacles",
      "imgurl":"images/portfolio/RoboSub/eagle2.jpg",
      "url":"https://csns.calstatela.edu/department/cs/project/view?id=6675265"
    },
    {
      "id":"2",
      "name":"RePath Tracker",
      "description":"Web, iOS, and Android app",
      "longDescription":"Multiplatform App to help reduce recidivism for parolee's",
      "stack":["Swift", "Kotlin","XCode","Android Studio","UIKit", "SwiftUI","Foundation", "Core Location", "AWS AppSync", "AWS Cognito", "AWS Lambda", "Twilio"],
      "responsibilities": "Responsible for Front End development for an iOS application using an AWS serverless backend.",
      "imgurl":"images/portfolio/RePath/eHawk.png",
      "url":"https://ehawksolutions.com/repath/"
    },
    {
      "id":"3",
      "name":"Strategic Employment Partners",
      "description":"Single-Page Application",  
      "stack":["ReactJS","HTML","CSS","Javascript","Amazon S3","Amazon Route 53"],
      "responsibilities": "Designed and Deployed a single page application as a landing page for the Strategic Employment Partness recruiting firm.",
      "imgurl":"images/portfolio/SEP/SEP_site.png",
      "url":"https://strategicemployment.com"
    },
    {
      "id":"4",
      "name":"Vivace Records",
      "description":"Web App",  
      "stack":["HTML","CSS","Javascript","Next.js","Selz","Amazon S3"],
      "responsibilities": "Solo Full Stack Developer. Used a static generator for a storefront for a small business. Product uses Selz as the CMS so the client and self-update the app with iminial costs",
      "imgurl":"images/portfolio/Vivace/vivace.png",
      "url":"https://www.vivacerecords.com"
    },
    {
      "id":"5",
      "name":"Travel Planner",
      "description":"iOS App",
      "longDescription":"A Mobile application to plan travel itineraries, with the ability for rebranding for different travel agencies.",
      "stack":["Swift","XCode","UIKit", "SwiftUI","Foundation", "Core Location", "AWS AppSync", "AWS Cognito", "AWS Lambda", "Twilio"],
      "responsibilities": "Full Stack Developer for an iOS application. Responsible for Domain Modeling and handling data within the app. Made builds and release to Test Flight. ",
      "imgurl":"images/portfolio/TravelPlanner/travel.png"
    },
    {
      "id":"6",
      "name":"Budget Impact Estimator",
      "description":"iPad App",
      "stack":[],
      "responsibilities": "Solo Full Stack Developer for a budgeting iOS application for Entertainment Producers. Implemented different union standard rates(DGA, SAG-AFTRA, IATSE) with Swift and XCode. Functionality app was to Store different Shoots/Projects in local memory using Core Data in case service was not available at location, then the user(Producer) would go through a paging controller if extra time was foreseen to be needed on-set. Producer would select Cast+Crew to stay Overtime with n amount of hours, then estimate would be generated and sent to Accountant's for approval. ",
      "imgurl":"images/portfolio/bie/bie.png",
      "url":""
    },
    {
      "id":"7",
      "name":"Jane",
      "description":"iOS and Android App to help with Legalized Marijuana banking problems",
      "stack":["Swift","Objective-C","Xcode","Realm","UIKit","Foundation","CoreData"],
      "responsibilities": "Did Stuff",
      "imgurl":"images/portfolio/Jane/jane.png",
      "url":"https://www.businessinsider.com/jane-marijuana-banking-2016-6"
    },
    {
      "id":"8",
      "name":"DrHolick.com",
      "description":"Personal Single Page Application for leading Vitamin D Authority Dr. Michael Holick",
      "stack":["HTML","CSS","Javascript","Bootstrap","Amazon S3","Route 53","SMTP"],
      "responsibilities": "Designed and Developed a single page application for Dr. Michael F. Holick. Designed mockups for the site using Adobe XD. Communicated with client to gather requirements and used an agile work methodology to produce releases for client through Amazon S3. Configured DNS and Domain services for the site using Route 53. Developed the single page application using basic HTML and CSS with Bootstrap, and implemented a mail client using JavaScript",
      "imgurl":"images/portfolio/drholick/drholick.png",
      "url":"https://drholick.com"
    },
    {
      "id":"9",
      "name":"Bishop McCann - CHAT",
      "description":"Ad Campaign for Bishop-McCann's CHAT Series",
      "stack":[],
      "responsibilities": "Full Stack Developer for implement designs created by Graphic Designers for an Ad Campaign for the Bishop McCann chat series. Took PSD files and implemented UI with HTML/CSS/Bootstrap",
      "imgurl":"images/portfolio/chatSeries/chat.png",
      "url":"https://bishopmccann.com/news/bishop-mccann-unveils-chat-2-0/"
    },
    {
      "id":"10",
      "name":"Arroyo Insurance",
      "description":"Web Application for displaying current Commercial and Personal insurance policies from Arroyo Insurance",
      "stack":[],
      "responsibilities": "Full Stack Developer, responsible for contacting customer and gathering requirements. Designed mock-ups for client and developed application using a java-based static site generator.",
      "imgurl":"images/portfolio/arroyo/arroyo.png",
      "url":"http://arroyo.ontometrics.com.s3-website-us-west-2.amazonaws.com"
    }    
  ],
  "testimonials":[
    {
      "description":"Dave is cool",
      "name":"Some technical guy"
    },
    {
      "description":"He taught me how to tie my shoes",
      "name":"Some technical guy"
    }
  ]
}

export default resumeData